import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Navigate, Outlet, Route, Routes, useNavigate } from 'react-router-dom';
import { PageLayout } from '../components/page-layout/page-layout';
import { useMeQuery } from '../graphql/types';
import { Index } from '../pages';
import { NotFound } from '../pages/404';
import { Admin } from '../pages/admin';
import { AdminDebug } from '../pages/admin/debug';
import { ContractingGroup } from '../pages/contracting-group';
import { CookiePolicy } from '../pages/cookie-policy';
import { Leaderboards } from '../pages/leaderboards';
import { Lego } from '../pages/lego';
import { Login } from '../pages/login';
import { Logout } from '../pages/logout';
import { Lot } from '../pages/lot';
import { Lots } from '../pages/lots';
import { MyLots } from '../pages/my-lots';
import { PersonalInfo } from '../pages/personal-info';
import { PrivacyPolicy } from '../pages/privacy-policy';
import { Register } from '../pages/register';
// import { Terms } from '../pages/terms';
import { OnRouteChange } from './on-route-change';

// ensure user is logged in
const Protected = () => {
  const auth0 = useAuth0();
  if (!auth0.isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};

export function AppRoutes() {
  const navigate = useNavigate();
  const me = useMeQuery({
    fetchPolicy: 'cache-first',
    errorPolicy: 'ignore',
  });

  useEffect(() => {
    const returnTo = localStorage.getItem('returnTo');
    if (returnTo) {
      localStorage.removeItem('returnTo');
      if (!me.data?.me?.paddle) {
        navigate(`/register?returnTo=${encodeURIComponent(returnTo)}`);
      } else {
        navigate(returnTo);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me.data?.me]);

  useEffect(() => {
    if (window.location.search.match(/\?.*?vip=true/)) {
      localStorage.setItem('nvvip', 'true');
    }
  }, []);

  return (
    <OnRouteChange>
      <Routes>
        <Route
          path=":year/leaderboards/:lotNumbers"
          element={<Leaderboards />}
        />
        <Route element={<PageLayout />}>
          <Route path="/" element={<Index />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="contracting-group" element={<ContractingGroup />} />
          <Route path="personal-info" element={<PersonalInfo />} />
          <Route path="register" element={<Register />} />
          <Route path="lego" element={<Lego />} />
          <Route path="login" element={<Login />} />
          <Route path=":year/lots/*" element={<Lots />} />
          <Route path="lots/*" element={<Lots />} />
          <Route path="lot/:lotId/*" element={<Lot />} />
          <Route element={<Protected />}>
            <Route path="admin/debug" element={<AdminDebug />} />
            <Route path="admin" element={<Admin />} />
            <Route path="my-lots/*" element={<MyLots />} />
            <Route path="logout" element={<Logout />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </OnRouteChange>
  );
}
